export const addExistingItemQuantity = <T extends { quantity: number }>(
  items: T[],
  existingItem?: T,
): T[] =>
  items.map((item) => {
    const adjustment = item === existingItem ? 1 : 0

    return {
      ...item,
      quantity: item.quantity + adjustment,
    }
  })
